import React, { useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
	onSearch: (keyword: string, reverseSelect: boolean) => void;
}

const SearchInput: React.FC<Props> = ({ onSearch }) => {
	const [t] = useTranslation();
	const [keyword, setKeyword] = useState("");
	const [reverseSelect, setReverseSelect] = useState<boolean>(false);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setKeyword(value);
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter") {
			onSearch(keyword, reverseSelect);
		}
	};

	return (
		<TextField
			color="success"
			variant="outlined"
			size="small"
			placeholder={t("userSystem.filterByKeyword")}
			value={keyword}
			onChange={handleChange}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<span className="material-icons  cursor-pointer" onClick={() => { setReverseSelect(!reverseSelect) }}> {reverseSelect ? 'filter_list_off' : 'filter_list'}</span>
					</InputAdornment>
				),
				endAdornment: (
					keyword && <InputAdornment position="end">
						<span className="material-icons cursor-pointer" onClick={() => {
							setKeyword("")
							onSearch("", reverseSelect)
						}}>close</span>
					</InputAdornment>
				)
			}}
			sx={{
				width: "250px",
				"& .MuiOutlinedInput-notchedOutline": {
					borderWidth: "0",
				},
				"& .MuiOutlinedInput-input,& .MuiOutlinedInput-input::placeholder": {
					fontSize: "14px",
				},
			}}
			onKeyDown={handleKeyDown}
		/>
	);
};

export default SearchInput;
